export default __webpack_public_path__ + "static/je-939d0715f7f9892690a6b07d8ac7c09a.svg";